import React from 'react';
import { format } from 'date-fns';
import { Message } from '../../lib/services/messageService';

interface MessageBubbleProps {
  message: Message;
  staffName?: string;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, staffName }) => {
  const isCustomer = message.sender_type === 'customer';
  const timestamp = format(new Date(message.created_at), 'h:mm a');

  return (
    <div className={`flex ${isCustomer ? 'justify-end' : 'justify-start'} mb-3`}>
      <div
        className={`max-w-[80%] rounded-2xl px-4 py-2 ${
          isCustomer
            ? 'bg-[#3A5E63] text-white rounded-br-md'
            : 'bg-[#E8F5F2] text-[#344854] rounded-bl-md'
        }`}
      >
        {/* Staff name label */}
        {!isCustomer && (
          <div className="text-xs font-medium text-[#3A5E63] mb-1">
            {staffName || 'Lotus Team'}
          </div>
        )}

        {/* Message content */}
        <p className="text-sm whitespace-pre-wrap break-words">{message.content}</p>

        {/* Timestamp */}
        <div
          className={`text-xs mt-1 ${
            isCustomer ? 'text-white/70' : 'text-[#344854]/60'
          }`}
        >
          {timestamp}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
